module.exports = __webpack_public_path__ + "static/media/1.edc21cc3.png";